import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import { editFormInput, editImageInput, getInputData, setImageSize } from '../store/forms';
import useIsMobile from '../hooks/useIsMobile';
import Title from './Title';
import PhotoInput from './PhotoInput';
import usePersonalDocuments from '../hooks/usePersonalDocuments';
import DateInput from './DateInput';
import BasicError from './BasicError';
import { useThemeCustomStyles } from '../hooks/useThemeConfig';

function DocumentsForm({ showValidation, error, refreshSize }) {
	const { 
		nextFile, 
		selectedFile, 
		setSelectedFile, 
        document,
        documentType,
        keys: {
            adelante,
            posterior,
            cedula,
            licencia
        },
	} = usePersonalDocuments();
	const view = "checkin2"; //
	const files = "files";
	const cedulaAdelante = useSelector(getInputData(view, files, cedula+adelante));
	const cedulaPosterior = useSelector(getInputData(view, files, cedula+posterior));
	const licenciaAdelante = useSelector(getInputData(view, files, licencia+adelante));
	const licenciaPosterior = useSelector(getInputData(view, files, licencia+posterior));
	const birthday = useSelector(getInputData(view, files, "birthday"));
	const identityCardExpiration = useSelector(getInputData(view, files, "identityCardExpiration"));
	const driveLicenseExpiration = useSelector(getInputData(view, files, "driveLicenseExpiration"));

	const dispatch = useDispatch();

	const handleChangeValue = (id, value, size) => {
		refreshSize();
		dispatch(editImageInput({ data: value, object: files, input: id, view, size, source: 'user' }));
		if (nextFile !== '') setSelectedFile(nextFile);
	};

	const setImgSize = (id, size) => {
		dispatch(setImageSize({ object: files, input: id, view, size }));
	};

	const handleChange = (id, event) => {
		const { size, data } = event;
		handleChangeValue(id, data, size);
	};

	const handleChangeDate = (id, value) => {
		dispatch(editFormInput({ data: value, object: files, input: id, view }));
	  };
	const small = useIsMobile();
	const styles = useThemeCustomStyles();
	const documentStyle = (document, selectedDocument) => styles.DocumentForm.DocumentStyle(document, selectedDocument, small);
	const documentTypeStyle = (type, selectedType) => styles.DocumentForm.DocumentTypeStyle(type, selectedType, small);



    const DocumentTabButton = (doc) => (<Button sx={documentStyle(doc.id,selectedFile)} onClick={() => {
		setSelectedFile(doc.id);
	}}>{doc.title}</Button>);
	const DocumentTypeTabButton = (doc) => (<Button sx={documentTypeStyle(doc,document)} onClick={() => {
		if (doc !== document){
			setSelectedFile(doc+adelante);
			refreshSize();
		}
	}}>{doc}</Button>);
	return (
		<Stack>
			<Title sx={{  }}>
		    	Documentos personales
		    </Title>
			<Grid container sx={{ height: '100%' }}>
				{error !== '' && (<Grid item xs={12} sx={{ justifyContent: 'center', alignItems: 'center'}}>
					<BasicError error={error} />
				</Grid>)}
				<Grid item xs={6} sx={styles.DocumentForm.DocumentTypeTabButtonGridItem}>
					{DocumentTypeTabButton(cedula)}
				</Grid>
				<Grid item xs={6} sx={styles.DocumentForm.DocumentTypeTabButtonGridItem}>
					{DocumentTypeTabButton(licencia)}
				</Grid>
				{document===cedula && (<Grid item xs={12} md={6} sx={styles.DocumentForm.DocumentTypeTabButtonGridItem} >
					<DateInput showValidation={showValidation} control={birthday} handleChange={(e) => handleChangeDate("birthday", e)} />
				</Grid>)}
				{document===cedula && (<Grid item xs={12} md={6} sx={styles.DocumentForm.DocumentTypeTabButtonGridItem} >
					<DateInput showValidation={showValidation} control={identityCardExpiration} handleChange={(e) => handleChangeDate("identityCardExpiration", e)} />
				</Grid>)}
				{document===licencia && (<Grid item xs={12} sx={styles.DocumentForm.DocumentTypeTabButtonGridItem} >
					<DateInput showValidation={showValidation} control={driveLicenseExpiration} handleChange={(e) => handleChangeDate("driveLicenseExpiration", e)} />
				</Grid>)}
				<Grid item xs={12} sx={{ p: 1}}/>
				{document===cedula && (<Grid item xs={6} sx={styles.DocumentForm.DocumentTabButtonGridItem}>
					{DocumentTabButton(cedulaAdelante)}
				</Grid>)}
				{document===cedula && (<Grid item xs={6} sx={styles.DocumentForm.DocumentTabButtonGridItem}>
					{DocumentTabButton(cedulaPosterior)}
				</Grid>)}
				{document===licencia && (<Grid item xs={6} sx={styles.DocumentForm.DocumentTabButtonGridItem}>
					{DocumentTabButton(licenciaAdelante)}
				</Grid>)}
				{document===licencia && (<Grid item xs={6} sx={styles.DocumentForm.DocumentTabButtonGridItem}>
					{DocumentTabButton(licenciaPosterior)}
				</Grid>)}
				{document === cedula && documentType === adelante && (<Grid item xs={12} sx={styles.DocumentForm.PhotoInputGridItem} >
					<PhotoInput showValidation={showValidation} saveMethod={(e) => handleChange(selectedFile, e)} control={cedulaAdelante} setImgSize={setImgSize} />
				</Grid>)}
				{document === cedula && documentType === posterior && (<Grid item xs={12} sx={styles.DocumentForm.PhotoInputGridItem} >
					<PhotoInput showValidation={showValidation} saveMethod={(e) => handleChange(selectedFile, e)} control={cedulaPosterior} setImgSize={setImgSize} />
				</Grid>)}
				{document === licencia && documentType === adelante && (<Grid item xs={12} sx={styles.DocumentForm.PhotoInputGridItem} >
					<PhotoInput showValidation={showValidation} saveMethod={(e) => handleChange(selectedFile, e)} control={licenciaAdelante} setImgSize={setImgSize} />
				</Grid>)}
				{document === licencia && documentType === posterior && (<Grid item xs={12} sx={styles.DocumentForm.PhotoInputGridItem} >
					<PhotoInput showValidation={showValidation} saveMethod={(e) => handleChange(selectedFile, e)} control={licenciaPosterior} setImgSize={setImgSize}  />
				</Grid>)}
			</Grid>
		</Stack>
	);
}

export default DocumentsForm;
